var app = angular.module("leonardo");

var TaskResolveDocumentFileDialog = function($scope, folder, FolderFileService, Upload, ConfigThemeService,
                                             FormErrorsService, NotificationService) {
  $scope.task = $scope.ngDialogData.task;

  $scope.folder = folder;
  if ($scope.folder) {
    $scope.folder_file = $scope.ngDialogData.entity ? $scope.ngDialogData.entity.plain() : FolderFileService.bulkObject(folder.id);
  }
  else {
    $scope.folder_file = {};
  }

  $scope.folder_file.name = $scope.ngDialogData.name;

  $scope.getData = function() {
    var fd = new FormData();
    fd.append('file', $scope.folder_file.file);
    $scope.folder_file['document_file'] = $scope.folder_file.file;
    $scope.folder_file['document_file']['file'] = fd;
    $scope.folder_file['document_file_name'] = $scope.folder_file.name;
    $scope.folder_file['document_file_expiration'] = $scope.folder_file.expiration;
    $scope.folder_file['document_file_notice'] = $scope.folder_file.notice;
    $scope.folder_file['document_file_notice_type'] = $scope.folder_file.notice_type;
    $scope.folder_file['completed_date'] = moment().format('YYYY-MM-DD');
    $scope.folder_file['status'] = 1;
    return $scope.folder_file;
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = $scope.getData();
    Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/action-items/' + $scope.task.id + '/mark-as-complete/'),
      data: data
    }).then(function(data_result){
      $scope.confirm(data_result);
    }, function (error) {
      NotificationService.error(error);
    });
  };
};

app.controller('TaskResolveDocumentFileDialog', ['$scope', 'folder', 'FolderFileService', 'Upload', 'ConfigThemeService',
  'FormErrorsService', 'NotificationService', TaskResolveDocumentFileDialog]);
